export const CountryList = Object.freeze({
  GREAT_BRITAIN: 'GB',
  SOUTH_AFRICA: 'ZA',
});

export const Country = Object.freeze({
  GB: {
    date: {
      format: 'dd-MM-yyyy',
    },
    currency: {
      symbol: '£',
      thousandSeparator: ',',
      code: 'GBP',
    },
    locale: 'en-gb',
  },
  ZA: {
    date: {
      format: 'yyyy-MM-dd',
    },
    currency: {
      symbol: 'R',
      thousandSeparator: ' ',
      code: 'ZAR',
    },
    locale: 'en-za',
  },
});

export const getCurrencySettingsByCode = (currencyCode = 'GBP') => {
  const byCurrencyCode = Object.values(Country)
    .map((countryDetails) => countryDetails.currency)
    .find((currencyDetails) => currencyDetails.code === currencyCode);
  if (!byCurrencyCode) {
    return Object.entries(Country).find(([countryKey]) => countryKey === currencyCode)?.[1]
      ?.currency;
  }
  return byCurrencyCode;
};
